import { ISvgProps } from '@src/types';

const Text = ({ width = '22px', height = '20px', fillColor = 'var(--font-color)', ...props }: ISvgProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 20"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Group" fill={fillColor} fillRule="nonzero">
          <polygon
            id="Path"
            points="8.25000588 2.75001753 11.0000235 2.75001753 11.0000235 4.12500277 13.7500412 4.12500277 13.7500412 0 0 0 0 4.12500277 2.75001764 4.12500277 2.75001764 2.75001753 5.50003527 2.75001753 5.50003527 16.5000111 2.75001764 16.5000111 2.75001764 19.2500286 10.9986596 19.2500286 10.9986596 16.5000111 8.25000588 16.5000111"
          ></polygon>
          <polygon
            id="Path"
            points="10.9999765 11.0000231 13.7499941 11.0000231 13.7499941 9.62503783 15.1249794 9.62503783 15.1249794 16.5000111 13.7499941 16.5000111 13.7499941 19.2500286 19.2499824 19.2500286 19.2499824 16.5000111 17.8749971 16.5000111 17.8749971 9.62499079 19.2499824 9.62499079 19.2499824 10.999976 22 10.999976 22 6.87497327 10.9999765 6.87497327"
          ></polygon>
        </g>
      </g>
    </svg>
  );
};

export default Text;
